/* jshint esversion: 6 */

import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetCloseForm extends React.Component {
  render() {
    return (
      <div id="hard-close-confirmation" className={this.props.className}>
        <div id="hard-close-confirmation-content">
          <span id="hard-close-confirmation-text">Are you sure you want to leave this conversation?</span>
          <div id="hard-close-no-button" onClick={this.props.onCancel} style={{
            background: this.props.primaryColor,
            color: this.props.textColor,
            ...this.props.shadowEnabled && { 'text-shadow': '-1px 0 rgba(0,0,0,0.2), 0 1px rgba(0,0,0,0.2), 1px 0 rgba(0,0,0,0.2), 0 -1px rgba(0,0,0,0.2)'},
          }}>No</div>
          <div id="hard-close-yes-button" onClick={this.props.onConfirm} style={{
            border: '2px solid ' + this.props.primaryColor,
            color: this.props.primaryColor,
            ...this.props.shadowEnabled && {'text-shadow': '-1px 0 rgba(0,0,0,0.2), 0 1px rgba(0,0,0,0.2), 1px 0 rgba(0,0,0,0.2), 0 -1px rgba(0,0,0,0.2)'},
          }}>Yes</div>
        </div>
      </div>
    );
  }
}

WebsiteWidgetCloseForm.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default WebsiteWidgetCloseForm;
